module.exports={turnstile_modal:{message:"Beveiligingsdetails verifiëren"}};